import React from 'react';
import './Pagination.css';

interface PaginationProps {
  paginaActual: number;
  totalPaginas: number;
  onPaginaAnterior: () => void;
  onPaginaSiguiente: () => void;
  onIrAPagina: (numeroPagina: number) => void;
}

const Pagination: React.FC<PaginationProps> = ({
  paginaActual,
  totalPaginas,
  onPaginaAnterior,
  onPaginaSiguiente,
  onIrAPagina
}) => {
  // Generar números de página para mostrar
  const generarNumerosPagina = () => {
    const numeros = [];
    const maxNumerosMostrar = 5;
    let inicio = Math.max(1, paginaActual - Math.floor(maxNumerosMostrar / 2));
    const fin = Math.min(totalPaginas, inicio + maxNumerosMostrar - 1);
    
    // Ajustar inicio si estamos cerca del final
    if (fin - inicio + 1 < maxNumerosMostrar) {
      inicio = Math.max(1, fin - maxNumerosMostrar + 1);
    }
    
    for (let i = inicio; i <= fin; i++) {
      numeros.push(i);
    }
    
    return numeros;
  };

  const numerosPagina = generarNumerosPagina();

  return (
    <div className="pagination-container">
      <div className="pagination">
        <button 
          type="button" 
          className="pagination-btn"
          onClick={onPaginaAnterior}
          disabled={paginaActual === 1}
        >
          Anterior
        </button>
        
        <div className="pagination-numbers">
          {numerosPagina.map((numeroPagina) => (
            <button 
              key={numeroPagina}
              type="button" 
              className={`pagination-number ${numeroPagina === paginaActual ? 'active' : ''}`}
              onClick={() => onIrAPagina(numeroPagina)}
            >
              {numeroPagina}
            </button>
          ))}
          {totalPaginas > 5 && paginaActual < totalPaginas - 2 && (
            <>
              <span className="pagination-dots">...</span>
              <button 
                type="button" 
                className="pagination-number"
                onClick={() => onIrAPagina(totalPaginas)}
              >
                {totalPaginas}
              </button>
            </>
          )}
        </div>
        
        <button 
          type="button" 
          className="pagination-btn"
          onClick={onPaginaSiguiente}
          disabled={paginaActual === totalPaginas}
        >
          Siguiente
        </button>
      </div>
    </div>
  );
};

export default Pagination;